import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/static-entry/add/$type")({});
